//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import ScsSeqConfigDrawer from "./modules/ScsSeqConfigDrawer";
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
export default {
  name: 'ScsSeqConfigList',
  mixins: [JeecgListMixin],
  components: {
    ScsSeqConfigDrawer: ScsSeqConfigDrawer
  },
  data: function data() {
    return {
      description: '自动编码配置管理页面',
      // 表头
      columns: [{
        title: '序号',
        dataIndex: '',
        key: 'rowIndex',
        width: 60,
        align: 'center',
        customRender: function customRender(t, r, index) {
          return parseInt(index) + 1;
        }
      }, {
        title: '编号名称',
        align: 'center',
        dataIndex: 'code'
      }, {
        title: '编号类型',
        align: 'center',
        dataIndex: 'category_dictText'
      }, {
        title: '日期生成格式',
        align: 'center',
        dataIndex: 'datePattern'
      }, {
        title: '实现类',
        align: 'center',
        dataIndex: 'service'
      }, {
        title: '前缀类型',
        align: 'center',
        dataIndex: 'preType'
      }, {
        title: '序号长度',
        align: 'center',
        dataIndex: 'seqLength'
      }, {
        title: '当前值',
        align: 'center',
        dataIndex: 'curNumber'
      }, {
        title: '步长',
        align: 'center',
        dataIndex: 'stepNumber'
      }, {
        title: '备注',
        align: 'center',
        dataIndex: 'remark'
      }, {
        title: '操作',
        dataIndex: 'action',
        align: 'center',
        scopedSlots: {
          customRender: 'action'
        }
      }],
      url: {
        list: '/sys/seq/list',
        delete: '/sys/seq/delete',
        deleteBatch: '/sys/seq/deleteBatch',
        exportXlsUrl: '/sys/seq/exportXls',
        importExcelUrl: '/sys/seq/importExcel'
      }
    };
  },
  computed: {
    importExcelUrl: function importExcelUrl() {
      return "".concat(window._CONFIG['domianURL'], "/").concat(this.url.importExcelUrl);
    }
  },
  methods: {}
};